import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEyeOn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M2.142 12.411C2.32 12.64 6.582 18 11.999 18c5.418 0 9.68-5.36 9.859-5.589a.667.667 0 0 0 0-.822C21.678 11.36 17.417 6 11.999 6c-5.417 0-9.679 5.36-9.857 5.589a.666.666 0 0 0 0 .822Zm9.857 4.256c-3.95 0-7.378-3.458-8.457-4.667 1.079-1.21 4.508-4.667 8.457-4.667 3.95 0 7.38 3.458 8.458 4.667-1.079 1.21-4.508 4.667-8.458 4.667Zm-1.851-1.896A3.333 3.333 0 1 0 13.85 9.23a3.333 3.333 0 0 0-3.703 5.543Zm.74-4.434a2 2 0 1 1 2.223 3.325 2 2 0 0 1-2.223-3.325Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEyeOn;
